export default {
      id: "truck-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#truck",
      toString: function () {
        return this.url;
      }
    }